import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';
import ModalTabuYashirRequestPending from '../ModalTabuYashirRequestPending';
import ModalTabuYashirRequestDone from '../ModalTabuYashirRequestDone';
import config from 'config/common';
import {errors as E} from 'common/constants/errors';

const STATE = {
  PENDING: 'pending',
  DONE: 'done',
  ERROR: 'server error',
  TIMEOUT: 'timeout',
  DEFAULT: 'default',
};

const timeout = config.tabu_yashir_api.request_timeout * 1000;

const ButtonTabuYashirServerRequest = ({
                                         showGlobalErrorMessage,
                                         getNesachTabu,
                                         data,
                                         onApprove,
                                         closeAreYouSureModal,
                                         setModalShown
                                       }) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [currentState, setCurrentState] = useState(null);
  const [progress, setProgress] = useState(0);
  const [file, setFile] = useState(0);
  const [source, setSource] = useState(null);
  const [tempData, setTempData] = useState({});

  const openModal = () => {
    setProgress(1);
    setCurrentState(STATE.PENDING);
    setIsOpen(true);
    postDataAndGetResult();
  };

  const closeModal = () => {
    if (currentState !== STATE.PENDING)
      setIsOpen(false);
  };

  const postDataAndGetResult = () => {
    const timer = setTimeout(onTimeout, timeout);
    const progressGrowSize = 10;
    const delayGrowFactor = 1.75;
    let delay = 500;
    let fakeProgress = 0;
    let timerId = setTimeout(function request() {
      fakeProgress += progressGrowSize;
      setProgress(fakeProgress);
      if (fakeProgress < 50) {
        delay *= delayGrowFactor;
        timerId = setTimeout(request, delay);
      } else {
        clearTimeout(timerId);
      }
    }, delay);
    getNesachTabu({data, onDownloadProgress: onDownloadProgress(timerId), setSource})
      .then(({file, registeredArea, houseRegisteredArea, sharedParts}) => {
        setFile(file);
        if (registeredArea > 0) {
          setTempData({registeredArea, houseRegisteredArea, sharedParts});
        }
      })
      .then(() => setCurrentState(STATE.DONE))
      .catch(() => {
        setCurrentState(STATE.ERROR);
      })
      .finally(() => clearTimeout(timer));
  };

  const onDownloadProgress = fakeTimeId => (progressEvent) => {
    clearTimeout(fakeTimeId);
    // Do whatever you want with the native progress event
    const {loaded, total} = progressEvent;
    const currentProgress = Math.ceil(50 * loaded / total + 50);
    setProgress(currentProgress);
  };

  const onTimeout = () => setCurrentState(STATE.TIMEOUT);

  const cancelRequest = () => {
    if (source !== null) {
      source.cancel('Operation canceled by the user.');
    }
  };

  const renderContent = () => {
    switch (currentState) {
      case STATE.DONE:
        return (
          <ModalTabuYashirRequestDone
            isOpen={modalIsOpen}
            close={closeModal}
            dataURI={file}
            onApprove={onApprove(tempData)}
            closeAreYouSureModal={closeAreYouSureModal}
          />
        );
      case STATE.PENDING:
        return (
          <ModalTabuYashirRequestPending
            isOpen={modalIsOpen}
            close={closeModal}
            progress={progress}
          />
        );
      case STATE.ERROR:
        showGlobalErrorMessage(E.SERVER_ERROR);
        setCurrentState(STATE.DEFAULT);
        closeAreYouSureModal();
        return null;
      case STATE.TIMEOUT:
        cancelRequest();
        showGlobalErrorMessage('timeout');
        setCurrentState(STATE.DEFAULT);
        return null;
      default:
        return null;
    }
  };

  return (
    <>
      <div
        className={styles.buttonSubmit}
        onClick={() => {
          openModal();
          setModalShown(false);
        }}
      >
        <span>אישור</span>
      </div>
      {renderContent()}
    </>
  );
};

ButtonTabuYashirServerRequest.propTypes = {
  showGlobalErrorMessage: PropTypes.func,
  getNesachTabu: PropTypes.func,
  data: PropTypes.object,
  closeAreYouSureModal: PropTypes.func,
  setModalShown: PropTypes.func,
};

export default ButtonTabuYashirServerRequest;
